import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getConditionsFilterConfig } from '../filters/condition';

const pinupgirlclothingSizes: string[] = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '1X',
  '2X',
  '2XL',
  '3X',
  '3XL',
  '4X',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  'One Size',
];

export const pinupgirlclothingShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: pinupgirlclothingSizes,
    }),
  ],
};
